import { createFileRoute } from '@tanstack/react-router';
import { AdminUsers } from './admin.users';

export const Route = createFileRoute('/instructor/users')({ component: AdminUsers });
